import {
  EMAIL_ID,
  CALL_ORIGIN_TARGETED_OFFERS,
} from 'contexts/CruiseSearchContext/constants';
import Decrypt from 'lib/utilities/Decrypt';
import Cookies from 'js-cookie';
import { validateTargetedOffersAvailable } from './validateTargetedOffersAvailable';
import { getStateTargetedOffer } from './getStateTargetedOffer';

export const fetchTargetedOffers = async ({
  updateState,
  inputData,
  globalization,
  initialState,
  apolloClient,
  query,
  toogles,
  targetedOffersLoading,
  removeFromQualifiersSelecting,
  applyFilters,
  config,
}) => {
  const { showTargetedOffersPerksQualifiers, enableDisabledPromotionMessage } =
    toogles;
  const { brand } = initialState;

  let input = {
    ...inputData,
  };

  updateState({
    targetedOffersLoading: true,
  });

  const originValid = [
    CALL_ORIGIN_TARGETED_OFFERS.URL,
    CALL_ORIGIN_TARGETED_OFFERS.COOKIE,
  ].includes(inputData.originCall);

  if (originValid && inputData.emailEncrypt) {
    try {
      const response = await Decrypt(inputData.emailEncrypt, config);
      if (response?.data) {
        input.email = response?.data?.text;
      } else {
        Cookies.remove(EMAIL_ID.cookie);
        input.email = inputData.emailEncrypt;
        input.emailEncrypt = null;
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Error Decrypt Service ', e);
      Cookies.remove(EMAIL_ID.cookie);
    }
  }

  const newTargetedOfferState = await getStateTargetedOffer({
    updateState,
    apolloClient,
    brand,
    globalization,
    input,
    targetedOffersLoading,
    showTargetedOffersPerksQualifiers,
    config,
  });

  if (originValid && Object.keys(query).length > 0) {
    validateTargetedOffersAvailable({
      updateState,
      query,
      newTargetedOfferState,
      enableDisabledPromotionMessage,
      removeFromQualifiersSelecting,
      applyFilters,
    });
  }
};
